export const RESUME_EMAILS_SET_DATA = 'RESUME_EMAILS_SET_DATA';



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/optionEmails/types.js
 **/